import { render, staticRenderFns } from "./SatisfactionChart.vue?vue&type=template&id=06f62308&scoped=true"
import script from "./SatisfactionChart.vue?vue&type=script&lang=js"
export * from "./SatisfactionChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f62308",
  null
  
)

export default component.exports